<form id="records-form-pg-1" [formGroup]="recordsFormGroup" cleanStepPanelAccessibility>
  <!-- Code Implementation for Records Information -->
  <div formArrayName="records" role="region">
        <span #stepHeading tabindex="-1" class="sr-only">Last step: Records Information</span>       
          <p-panel [header]="'Provider' + i" styleClass="mb-3 panel-bg-color border panel-dotted-heading" *ngFor="let record of records.controls; let i = index" [formGroupName]="i"
          [ngClass]="{ 'mt-2rem panel-bg-color': i > 0 }">
              <div class="row">
                  <div class="col-sm-12">
                      <div class="border-bottom-dotted d-flex justify-content-between align-items-center py-2 px-3">
                          <h2 #recordsHeaders tabindex="-1" class="recordListNo mb-0">
                              <span *ngIf="i<9">Provider {{ '0'+ (i + 1) }}</span>
                              <span *ngIf="i>=9">Provider {{ i + 1 }}</span>
                          </h2>
                          <div>
                            <p-button icon="pi pi-list" styleClass="p-0 mb-1 me-2" [link]="true" [text]="true" label="Split Request" (onClick)="splitRequest(i)"  *ngIf="editOrder" [disabled]="editOrder && !(record?.value?.selectedTypes?.length > 1)"></p-button>  
                            <p-button icon="pi pi-trash" styleClass="p-0 mb-1" [link]="true" [text]="true"
                              aria-label="Delete" label="Delete" (onClick)="removeRecord(i)" *ngIf="(i > 0 && i === (records.length-1)) || (records.length > 1 && i < (records.length-1))" [disabled]="editOrder && !record?.value?.isNew"></p-button>
                          <!-- <p-button *ngIf="records.length > 1 && i < (records.length-1) && !record.value.isEditMode" icon="pi pi-pencil" styleClass="p-0 mb-1 ms-4" [link]="true" [text]="true"
                              aria-label="Edit" label="Edit" (onClick)="editRecord(record,i)"></p-button> -->
                          </div>
                      </div>
                  </div>
                  <!--  <hr /> -->
              </div>
              <!-- View only section -->
              <!-- <ng-container *ngIf="records.length > 1 && i < (records.length-1) && !record.value.isEditMode">
                  <div class="p-3">
                  <div class="row mb-3">
                  <div class="col-sm-4 mb-3 mb-sm-0">
                      <label class="ms-2">
                          <span class="mb-2 medium-text">Provider (Institution): </span>
                          {{ record.value.providerName }}</label>
                  </div>
                  <div class="col-sm-4 mb-3 mb-sm-0">
                      <label class="ms-2">
                          <span class="mb-2 medium-text">Doctor: </span>
                          {{ record.value.doctor ? record.value.doctor : '-' }}</label>
                  </div>                          
                    <div class="col-sm-4 mb-3 mb-sm-0">
                      <label class="ms-2">
                          <span class="mb-2 medium-text">Address: </span>
                          {{ getCompleteAddress(record.value.streetAddress, record.value.cityName, record.value.stateName, record.value.zipCode) }}</label>
                  </div>
                  </div>
                  <div class="row mb-3">
                  <div class="col-sm-4 mb-3 mb-sm-0">
                      <label class="ms-2">
                          <span class="mb-2 medium-text">Email: </span>
                          {{ record.value.email ? record.value.email : '-' }}</label>
                  </div>
                  <div class="col-sm-4 mb-3 mb-sm-0">
                      <label class="ms-2">
                          <span class="mb-2 medium-text">Record Subject: </span>
                          {{ record.value.subject }}</label>
                  </div>            
                  <div class="col-sm-4 mb-3 mb-sm-0">
                      <label class="ms-2" *ngIf="record.value.range.length > 0">
                          <span class="mb-2 medium-text">Record Range: </span>
                          Any or All</label>
                      <label class="ms-2" *ngIf="record.value.range.length <= 0">
                          <span class="mb-2 medium-text">Date of service: </span>
                          {{ record.value.dateToServiceFrom | date: 'dd/MM/yyyy' }} to {{ record.value.dateToServiceTo | date: 'dd/MM/yyyy' }}</label>
                  </div>
                  </div>
                  <div class="row mb-0 mb-lg-3">
                      <div class="col-sm-12 mb-3 mb-sm-0">
                          <label class="ms-2">
                              <span class="mb-2 medium-text">Record Type Requested: </span>
                              {{ getSelectedRequestTypes(record) }}</label>
                      </div>
                  </div>
                  <div class="row mb-3" *ngIf="showAdditionalDetails(record)">
                      <div class="col-sm-12 mb-3 mb-sm-0">
                          <label class="ms-2">
                              <span class="mb-2 medium-text">Additional Section: </span></label>
                      <div class="details-container ps-3">
                          <div *ngFor="let controlName of objectKeys(record.value)">
                              <div *ngIf="isControlIncluded(record, controlName) && isObject(record.value[controlName])">
                                      <ng-container *ngIf="!isSpecialCase(controlName)">
                                      <label class="bullet-underline"><i class="pi pi-circle-fill me-2" style="font-size: 0.6rem;"></i><u><span class="semi-bold-text">{{ getDisplayName(controlName) === 'Diagnostic Images' ? 'Types Of Imaging' : getDisplayName(controlName) }}</span></u></label>
                                          <div *ngFor="let key of objectKeys(record.value[controlName])">
                                                  <ng-container *ngIf="hideReadOnlyFields(key,record.value[controlName][key] )">
                                                  <label class="ms-3">
                                                      <span class="mb-2 medium-text">
                                                          {{ getDisplayName(key) }}:
                                                      </span>{{ record.value[controlName][key] ? record.value[controlName][key] : '--'  }}
                                                  </label>
                                                  </ng-container>
                                                  <ng-container *ngIf="getDisplayName(key) === 'Types Of Imaging'">
                                                  <label class="ms-3">
                                                      {{ getDisplayListOfTypesOfImaging(record.value[controlName][key])  }}
                                                  </label>
                                                  </ng-container>
                                          </div>
                                      </ng-container>
                                      <ng-container *ngIf="isSpecialCase(controlName)">
                                      <label class="bullet-underline"><i class="pi pi-circle-fill me-2" style="font-size: 0.6rem;"></i><u><span class="semi-bold-text">{{ getDisplayName(controlName) === 'Diagnostic Images' ? 'Types Of Imaging' : getDisplayName(controlName) }}</span></u></label>
                                          <div>  
                                          <label class="ms-3">
                                                  <ng-container *ngIf="getDisplayName(controlName) === 'Ambulance'">
                                                      <span class="mb-2 medium-text">
                                                          Date of Ambulance Service:
                                                      </span>
                                                      {{ record.value[controlName].date | date: 'dd/MM/yyyy' }} 
                                                      <br />
                                                      <span class="mb-2 medium-text">
                                                          Time of Ambulance Service:
                                                      </span>
                                                      {{ record.value[controlName].time ? record.value[controlName].time : '--'  }} 
                                                      <br />
                                                      <span class="mb-2 medium-text">
                                                          Pickup Address:
                                                      </span>
                                                      {{ getCompleteAddress(record.value[controlName].pickupAddress, record.value[controlName].pickupCity, record.value[controlName].pickupState, record.value[controlName].pickupZip) }}
                                                      <br />
                                                      <span class="mb-2 medium-text">
                                                          Drop Address:
                                                      </span>
                                                      {{ getCompleteAddress(record.value[controlName].dropAddress, record.value[controlName].dropCity, record.value[controlName].dropState, record.value[controlName].dropZip) }}
                                                  </ng-container>
                                                  <ng-container *ngIf="getDisplayName(controlName) === 'Social Security'">
                                                      <span class="mb-2 medium-text">
                                                          SS#:
                                                      </span>
                                                      {{ record.value[controlName].socialSecuritySS  }} 
                                                      <br />
                                                      <span class="mb-2 medium-text">
                                                          Record Subject Address:
                                                      </span>
                                                      {{ getCompleteAddress(record.value[controlName].address, record.value[controlName].city, record.value[controlName].state, record.value[controlName].zip) }}
                                                  </ng-container>
                                                  <ng-container *ngIf="getDisplayName(controlName) === 'VA'">
                                                      <span class="mb-2 medium-text" *ngIf="record.value.va.medical || !record.value.va.benefit">
                                                          Medical records
                                                      </span>
                                                      <br />
                                                      <span class="mb-2 medium-text" *ngIf="record.value.va.benefit || !record.value.va.medical">
                                                          Benefit records
                                                      </span>
                                                  </ng-container>
                                              </label>
                                          </div>
                                      </ng-container> 
                              </div>
                          </div>
                      </div>
                      </div>
                  </div>
                  <div class="row mb-3" *ngIf="record.value.subpoenaLanguageTextarea">
                      <div class="col-sm-12 mb-3 mb-sm-0">
                          <label class="ms-2">
                              <span class="mb-2 medium-text">Subpoena language: </span>
                              {{ record.value.subpoenaLanguageTextarea }}</label>
                      </div>
                  </div>
                  <div class="row mb-3" *ngIf="record.value.notesTextarea">
                      <div class="col-sm-12 mb-3 mb-sm-0">
                          <label class="ms-2">
                              <span class="mb-2 medium-text">Notes: </span>
                              {{ record.value.notesTextarea }}</label>
                      </div>
                  </div>
                  </div>
              </ng-container>  -->
                  <div class="p-3">
                      <div class="row mb-3" *ngIf="isSearchProviderEnabled">
                          <div class="col-12">
                              <app-contact-search (onSelect)="onContactSelect($event, i)"></app-contact-search>
                          </div>
                      </div>
                      <div class="row">
                      <!-- Provider and Doctor on their own row -->
                      <div class="col-sm-12 col-md-6 col-lg-6 mb-3">
                          <label for="record-provider-name-{{i}}" class="form-label d-block required-asterisk">Provider
                              (Institution)</label>
                          <input pInputText type="text" id="record-provider-name-{{i}}" class="w-100"
                              placeholder="Enter provider (institution)" formControlName="providerName"
                              [ngClass]="{'ng-invalid ng-dirty' : isError('providerName', record)}" sanitizePaste/>
                          <small id="record-provider-name-error" *ngIf="isError('providerName', record)" class="error-label">This
                              field is mandatory</small>
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-6 mb-3">
                          <label for="record-doctor-{{i}}" class="form-label d-block">Doctor</label>
                          <input pInputText type="text" id="record-doctor-{{i}}" class="w-100" placeholder="Enter doctor"
                              formControlName="doctor" [ngClass]="{'ng-invalid ng-dirty' : isError('doctor', record)}" sanitizePaste/>
                          <small id="record-doctor-error" *ngIf="isError('doctor', record)" class="error-label">This
                              field is mandatory</small>
                      </div>
                      </div>
                      
                      <!-- Address, Apt, State, City on the next row -->
                      <div class="row">
                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                          <label for="record-street-address-{{i}}" class="form-label d-block">Street
                              Address</label>
                          <input pInputText type="text" id="record-street-address-{{i}}" class="w-100"
                              placeholder="Enter street address" formControlName="streetAddress" sanitizePaste/>
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                          <label for="record-apt-suite-other-{{i}}"
                              class="form-label d-block">Apt/Suite/other</label>
                          <input pInputText type="text" id="record-apt-suite-other-{{i}}" class="w-100"
                              placeholder="Enter apt/suite/other" formControlName="aptSuiteOther" sanitizePaste/>
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                          <label for="record-state-{{i}}" class="form-label d-block">State</label>
                          <p-select formControlName="stateName" id="record-state-{{i}}" [options]="states"
                              optionLabel="name" placeholder="Select state"
                              styleClass="w-100" />
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                          <label for="record-city-name-{{i}}" class="form-label d-block">City</label>
                          <input pInputText type="text" id="record-city-name-{{i}}" class="w-100" placeholder="Enter city"
                              formControlName="cityName" sanitizePaste/>
                      </div>
                      </div>
                      
                      <!-- Zip and Phone Extension on a row -->
                      <div class="row">
                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                          <label for="record-zip-{{i}}" class="form-label d-block">Zip</label>
                          <input pInputText type="text" id="record-zip-{{i}}" class="w-100" placeholder="Enter zip"
                              formControlName="zipCode" sanitizePaste/>
                      </div>
                        <div class="col-8 col-md-4 col-lg-2 mb-3 mb-sm-0 pe-1">
                            <label for="record-phone-{{i}}" class="form-label d-block">Phone</label>
                            <p-inputmask mask="(999) 999-9999" id="record-phone-{{i}}" class="w-100 phone-inputmask"
                                placeholder="Enter phone" formControlName="phone" autocomplete="new-password"/>
                        </div>
                        <div class="col-4 col-md-2 col-lg-1 mb-3 mb-sm-0 ps-1">
                            <label for="record-phone-extn-{{i}}"
                                class="form-label d-block">Extension</label>
                            <input pInputText type="text" id="record-phone-extn-{{i}}"
                                placeholder="Enter" formControlName="extn" class="w-100" />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                            <label for="record-fax-{{i}}" class="form-label d-block">Fax</label>
                            <input pInputText type="text" id="record-fax-{{i}}" class="w-100" placeholder="Enter fax"
                        formControlName="fax" />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                            <label for="record-email-{{i}}" class="form-label d-block">Email</label>
                            <input pInputText type="text" id="record-email-{{i}}" class="w-100" placeholder="Enter email"
                                formControlName="email" />
                            <small *ngIf="record.get('email')?.hasError('email')" class="error-label">Please
                                enter a valid email address.</small>
                        </div>
                      </div>
                  <!-- </div>
                  <div class="row mb-3"> -->
                      <div class="row">
                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                          <label for="record-subject-{{i}}" class="form-label d-block required-asterisk">Record
                              Subject</label>
                          <p-dropdown [options]="subjectNames" formControlName="subject" id="record-subject-{{i}}"
                              placeholder="Select record subject"
                              styleClass="w-100"
                              [ngClass]="{'ng-invalid ng-dirty' : isError('subject', record)}"
                              (onChange)="onRecordSubjectChange(record, i)" />
                          <small id="record-subject-error" *ngIf="isError('subject', record)" class="error-label">This field
                              is mandatory</small>
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                          <label for="record-range-{{i}}" class="form-label d-block">Record
                              Range</label>
                          <p-checkbox formControlName="range" inputId="record-range-label-{{i}}-label" value="anyorall" id="record-range-{{i}}" (onChange)="toggleAllImagingTypes(record)" />
                          <label for="record-range-label-{{i}}-label" class="ms-2 mt-2">Any or All</label>
                      </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 mb-3" *ngIf="record.value.range.length <= 0">
                        <label for="date-of-date-to-serviceFrom" class="form-label d-block required-asterisk">Date to service from</label>
                        <p-datepicker dateMask inputId="date-of-date-to-serviceFrom" placeholder="mm/dd/yyyy" showIcon iconDisplay="input"
                            styleClass="w-100" [maxDate]="maxDate" formControlName="dateToServiceFrom" (ngModelChange)="onDateChange($event, i, 'serviceFromDate')"
                            [ngClass]="{'ng-invalid ng-dirty' : isError('dateToServiceFrom', record)}" appendTo="body" />
                        <small id="date-to-serviceFrom-error" *ngIf="isError('dateToServiceFrom', record) && !record.get('dateToServiceFrom')?.errors?.['maxDateExceeded']" class="error-label">This field
                            is mandatory</small>
                        <small id="date-to-serviceFrom-error" *ngIf="record.get('dateToServiceFrom')?.errors?.['maxDateExceeded']" class="error-label">Please enter a valid date</small>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 mb-3" *ngIf="record.value.range <= 0">
                          <label for="date-of-date-to-serviceTo" class="form-label d-block required-asterisk">Date to service to</label>
                          <p-datepicker dateMask inputId="date-of-date-to-serviceTo" placeholder="mm/dd/yyyy" (ngModelChange)="onDateChange($event, i, 'serviceToDate')"
                          showIcon iconDisplay="input" styleClass="w-100" [maxDate]="maxDate"formControlName="dateToServiceTo"  [ngClass]="{'ng-invalid ng-dirty' : isError('dateToServiceTo', record)}" appendTo="body"/>
                          <small id="date-to-serviceTo-error" *ngIf="isError('dateToServiceTo', record) && !record.get('dateToServiceTo')?.hasError('invalidDateRange') && !record.get('dateToServiceTo')?.errors?.['maxDateExceeded']" class="error-label">This field
                              is mandatory</small>
                          <small id="date-to-serviceFrom-error"
                            *ngIf="isError('dateToServiceTo', record) && record.get('dateToServiceTo')?.hasError('invalidDateRange') && !record.get('dateToServiceTo')?.errors?.['maxDateExceeded']"
                            class="error-label">'Date to service to' should not be earlier than 'Date to service from'</small>
                          <small id="date-to-serviceTo-error" *ngIf="record.get('dateToServiceTo')?.errors?.['maxDateExceeded']" class="error-label">Please enter a valid date</small>
                    </div>
                  </div>
                  <div class="row">
                      <div class="col-sm-12 col-md-6 col-lg-3">
                          <label for="record-range-{{i}}" class="form-label d-block required-asterisk">Record Type
                              Requested</label>
                      </div>
                  </div>
                  <div class="row mb-3">
                      <div class="col-sm-3 mb-1 mb-sm-0" *ngFor="let type of requestedRecordTypes">
                          <p-checkbox  [value]="type.key" formControlName="selectedTypes" inputId="record-{{type.key}}-checkbox-label-{{i}}"
                          (onChange)="onSelectRequestedRecord($event, type.name, record)" 
                                              id="record-{{type.key}}-checkbox-{{i}}" [ngClass]="{'ng-invalid ng-dirty' : isError('selectedTypes', record)}"/>
                          <label for="record-{{type.key}}-checkbox-label-{{i}}" class="ms-2 mt-2" >{{type.name}}</label>
                      </div>
                      <small id="selectedTypes-error" *ngIf="isError('selectedTypes', record)" class="error-label">This field
                          is mandatory</small>
                  </div>
                  <ng-container *ngIf="showAdditionalDetails(record)">
                      <label class="form-label d-block mt-3">Please provide additional details.</label>
                      <p-card>    
                      <ng-container *ngIf="checkRecordType(record, 'diagnostic-images')">
                          
                                  <div formGroupName="diagnosticImages">
                                    <div class="row">
                                      <div class="col-sm-12 col-md-6 col-lg-3">
                                          <label class="form-label d-block">Type of Imaging</label>
                                      </div>
                                    </div>
                                      <div class="row mb-3">
                                          <div class="col-auto mb-3 mb-sm-0 records-imaging-type"
                                              *ngFor="let type of typesOfImaging; let i = index">
                                              <p-checkbox formControlName="typesOfImaging" [value]="type"
                                                  id="type-of-imaging-checkbox-{{ i }}"  inputId="type-of-imaging-checkbox-label-{{ i }}-label"
                                                  (onChange)="onTypeChange(record,type, $event)"/>
                                              <label for="type-of-imaging-checkbox-label-{{ i }}-label" class="ms-2">{{ type.name
                                                  }}</label>
                                          </div>
                                      </div>
                                      <div class="row"  *ngIf="isOtherImagingTypeSelected(record)">
                                          <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                              <label for="record-type-other"
                                                  class="form-label required-asterisk">Other (please
                                                  specify)</label>
                                              <input pInputText type="text" id="record-type-other" class="w-100"
                                                  placeholder="Enter here..." formControlName="other" [ngClass]="{'ng-invalid ng-dirty' : isError('diagnosticImages', record)}"/>
                                                  <small id="record-type-othe-error" *ngIf="isError('diagnosticImages', record)" class="error-label">This field
                                                      is mandatory</small>
                                          </div>
                                      </div>
                                      <div class="row">
                                          <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                              <label for="record-type-body-part" class="form-label">Specific Body
                                                  Part/Area (if applicable)</label>
                                              <input pInputText type="text" id="record-type-body-part" class="w-100"
                                                  placeholder="Enter here..." formControlName="specificBodyPart" />
                                          </div>
                                      </div>
                                  
                                  </div>
                                  <!-- </p-card> -->
                              </ng-container>

                              <ng-container *ngIf="checkRecordType(record, 'social-security')">
                                  <!-- <p-card> -->
                                  <div formGroupName="socialSecurity" class="selected-record-container">
                                      <label class="form-label d-block">Social Security</label>
                                      <div class="row">
                                          <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                              <label for="ss" class="form-label required-asterisk">SS#</label>
                                              <input pInputText type="text" id="ss" class="w-100" placeholder="Enter SS#"
                                                  formControlName="socialSecuritySS" [ngClass]="{
                            'ng-invalid ng-dirty': isError('socialSecurity.socialSecuritySS', record)
                          }" />
                                              <small id="socialSecuritySS-error" *ngIf="isError('socialSecurity.socialSecuritySS', record)"
                                                  class="error-label">This field is mandatory</small>
                                                  <small *ngIf="checkSubjectMismatchError(record.get('subject')?.value) && !isError('socialSecurity.socialSecuritySS', record)" class="error-label">
                                                      The SS# values for record subject {{ record.get('subject')?.value }} should match
                                                  </small>                                                  
                                          </div>
                                          <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                              <label for="securty-address"
                                                  class="form-label required-asterisk">Street Address (Record
                                                  Subject)</label>
                                              <input pInputText type="text" id="securty-address" class="w-100"
                                                  placeholder="Enter street address" formControlName="address" [ngClass]="{
                            'ng-invalid ng-dirty': isError('socialSecurity.address', record)
                          }" />
                                              <small id="address-error" *ngIf="isError('socialSecurity.address', record)"
                                                  class="error-label">This field is mandatory</small>
                                          </div>
                                          <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                              <label for="securty-address-city"
                                                  class="form-label required-asterisk">City</label>
                                              <input pInputText type="text" id="securty-address-city" class="w-100"
                                                  placeholder="Enter city" formControlName="city" [ngClass]="{
                            'ng-invalid ng-dirty': isError('socialSecurity.city', record)
                          }" />
                                              <small id="city-error" *ngIf="isError('socialSecurity.city', record)"
                                                  class="error-label">This field is mandatory</small>
                                          </div>
                                          <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                              <label for="securty-address-state"
                                                  class="form-label required-asterisk">State</label>
                                              <p-select id="securty-address-state" [options]="states" optionLabel="name"
                                                  placeholder="Select state" styleClass="w-100" formControlName="state"
                                                  [ngClass]="{
                            'ng-invalid ng-dirty': isError('socialSecurity.state', record)
                          }" />
                                              <small id="state-error" *ngIf="isError('socialSecurity.state', record)"
                                                  class="error-label">This field is mandatory</small>
                                          </div>
                                      </div>
                                  <div class="row">
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="securty-address-zip required-asterisk" class="form-label d-block">Zip</label>
                                          <input pInputText type="text" id="securty-address-zip" class="w-100" placeholder="Enter zip" formControlName="zip" [ngClass]="{'ng-invalid ng-dirty' : isError('socialSecurity.zip', record)}" />
                                          <small id="zip-error" *ngIf="isError('socialSecurity.zip', record)" class="error-label">This
                                              field is mandatory</small>
                                      </div>
                                  </div>
                              </div>
                              
                          </ng-container>
                          
                          <ng-container *ngIf="checkRecordType(record, 'ambulance')">
                                  <div formGroupName="ambulance">
                                  <label class="form-label d-block">Ambulance</label>
                                  <div class="row">
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="date-of-ambulance-service" class="form-label d-block required-asterisk">Date of Ambulance Service</label>
                                          <p-datepicker dateMask inputId="date-of-ambulance-service" placeholder="mm/dd/yyyy" appendTo="body"
                                          showIcon iconDisplay="input" styleClass="w-100" formControlName="date" [maxDate]="maxDate" (onInput)="onDateChange($event, i, 'ambulanceServiceDate')"
                                          [ngClass]="{'ng-invalid ng-dirty' : isError('ambulance', record)}"/>
                                          <small id="date-of-ambulance-service-error" *ngIf="isError('ambulance', record) && !record.get('ambulance.date')?.errors?.['maxDateExceeded']" class="error-label">This field
                                              is mandatory</small>
                                          <small id="date-of-ambulance-service-error" *ngIf="record.get('ambulance.date')?.errors?.['maxDateExceeded']" class="error-label">Please enter a valid date</small>

                                      </div>
                                        <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="time-of-ambulance-service" class="form-label d-block">Time of Ambulance Service</label>
                                          <input pInputText type="text" id="time-of-ambulance-service" class="w-100"
                                              placeholder="Enter time" formControlName="time" />
                                        </div> 
                                  </div>
                                  <div class="row">
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="street-address-pickup" class="form-label d-block">Street Address (Pickup)</label>
                                          <input pInputText type="text" id="street-address-pickup" class="w-100"
                                              placeholder="Enter street address" formControlName="pickupAddress" />
                                      </div>
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="pickup-city" class="form-label d-block">City</label>
                                          <input pInputText type="text" id="pickup-city" class="w-100" placeholder="Enter city"  formControlName="pickupCity" />
                                      </div>
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="pickup-state" class="form-label d-block">State</label>
                                          <p-select id="pickup-state" [options]="states"
                                          optionLabel="name" placeholder="Select state" styleClass="w-100"  formControlName="pickupState" />
                                      </div>
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="pickup-zip" class="form-label d-block">Zip</label>
                                          <input pInputText type="text"  id="pickup-zip" class="w-100" placeholder="Enter zip"  formControlName="pickupZip"/>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="street-address-drop" class="form-label d-block">Street Address (Drop)</label>
                                          <input pInputText type="text" id="street-address-drop" class="w-100"
                                              placeholder="Enter street address"  formControlName="dropAddress"/>
                                      </div>
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="drop-city" class="form-label d-block">City</label>
                                          <input pInputText type="text" id="drop-city" class="w-100" placeholder="Enter city"  formControlName="dropCity" />
                                      </div>
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="drop-state" class="form-label d-block">State</label>
                                          <p-select id="drop-state" [options]="states"
                                          optionLabel="name" placeholder="Select state" styleClass="w-100"  formControlName="dropState"/>
                                      </div>
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="drop-zip" class="form-label d-block">Zip</label>
                                          <input pInputText type="text" id="drop-zip" class="w-100" placeholder="Enter zip"  formControlName="dropZip"/>
                                      </div>
                                  </div>
                              </div>
                          </ng-container>
                      
                          <ng-container *ngIf="checkRecordType(record, 'insurance')">
                                  <div formGroupName="insurance">
                                  <label class="form-label d-block">Insurance</label>
                                  <div class="row">
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="claim-number" class="form-label d-block required-asterisk">Claim Number</label>
                                          <input pInputText type="text" id="claim-number" class="w-100"
                                              placeholder="Enter claim number" formControlName="claimNumber"
                                              [ngClass]="{'ng-invalid ng-dirty' : isError('insurance', record)}"/>
                                              <small id="claim-number-service-error" *ngIf="isError('insurance', record)" class="error-label">This field
                                                  is mandatory</small>
                                      </div>
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="policy-number" class="form-label d-block">Enter Policy Number</label>
                                          <input pInputText type="text" id="policy-number" class="w-100"
                                              placeholder="Enter policy number" formControlName="policyNumber"/>
                                      </div>
                                  </div>
                              </div>
                          </ng-container>
                          
                          <ng-container *ngIf="checkRecordType(record, 'employment')">
                              <div formGroupName="employment">
                                  <label class="form-label d-block">Employment</label>
                                  <div class="row">
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                              <label for="ss" class="form-label d-block required-asterisk">SS#</label>
                                              <input pInputText type="text" id="ss" class="w-100"
                                                  placeholder="Enter SS#" formControlName="employmentSS" [ngClass]="{'ng-invalid ng-dirty' : isError('employment', record)}" />
                                                  <small id="employmentSS-error" *ngIf="isError('employment', record)" class="error-label">This
                                                      field is mandatory</small>
                                                      <small *ngIf="checkSubjectMismatchError(record.get('subject')?.value) && !isError('employment', record)" class="error-label">
                                                          The SS# values for record subject {{ record.get('subject')?.value }} should match
                                                      </small>
                                      </div>
                              </div>
                          </div>  
                          </ng-container>
                          
                          <ng-container *ngIf="checkRecordType(record, 'military')">
                                  <div formGroupName="military">
                                  <label class="form-label d-block">Military</label>
                                  <div class="row">
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="branch" class="form-label d-block">Branch (if known)</label>
                                          <input pInputText type="text" id="branch" class="w-100"
                                              placeholder="Enter branch" formControlName="branch"/>
                                      </div>
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="service-number" class="form-label d-block">Service Number (if known)</label>
                                          <input pInputText type="text" id="service-number" class="w-100"
                                              placeholder="Enter service number" formControlName="serviceNumber" />
                                      </div>
                                  </div>
                              </div>
                          </ng-container>

                          <ng-container *ngIf="checkRecordType(record, 'irs')">
                              <div formGroupName="irs">
                                  <label class="form-label d-block">IRS</label>
                                  <div class="row">
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="ss" class="form-label d-block required-asterisk">SS#</label>
                                          <input pInputText type="text" id="ss" class="w-100" formControlName="irsSS" [ngClass]="{'ng-invalid ng-dirty' : isError('irs', record)}" placeholder="Enter SS#"/>
                                          <small id="irsSS-error" *ngIf="isError('irs', record)" class="error-label">This
                                              field is mandatory</small>
                                              <small *ngIf="checkSubjectMismatchError(record.get('subject')?.value) && !isError('irs', record)" class="error-label">
                                                  The SS# values for record subject {{ record.get('subject')?.value }} should match
                                              </small>
                                      </div>
                              </div>
                          </div> 
                          </ng-container>
                      
                          <ng-container *ngIf="checkRecordType(record, 'union')">
                              <div formGroupName="union">
                                  <label class="form-label d-block">Union</label>
                                  <div class="row">
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="membership-number" class="form-label d-block">Membership Number (if known)</label>
                                          <input pInputText type="text" id="membership-number" class="w-100"
                                              placeholder="Enter membership number" formControlName="membershipNumber"/>
                                      </div>
                                  </div>
                              </div> 
                          </ng-container>
                          
                          <ng-container *ngIf="checkRecordType(record, 'other')">
                              <div formGroupName="other">
                                  <label class="form-label d-block">Other</label>
                                  <div class="row">
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <label for="description-of-records" class="form-label d-block required-asterisk">Description of Records</label>
                                          <input pInputText type="text" id="description-of-records" class="w-100"
                                              placeholder="Enter other" formControlName="descriptionOfRecords" [ngClass]="{'ng-invalid ng-dirty' : isError('other', record)}" />
                                              <small id="descriptionOfRecords-error" *ngIf="isError('other', record)" class="error-label">This
                                                  field is mandatory</small>
                                      </div>
                                  </div>
                              </div> 
                          </ng-container>
                          
                          <ng-container *ngIf="checkRecordType(record, 'va')">
                                  <div formGroupName="va">
                                  <div class="row">
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <p-checkbox value="medical-records"
                                              id="medical-records" formControlName="medical" inputId="medical-records-label"/>
                                          <label for="medical-records-label" class="ms-2 mt-2">Medical Records</label>
                                      </div>
                                      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                          <p-checkbox value="benefit-records"
                                                  id="benefit-records" formControlName="benefit" inputId="benefit-records-label"/>
                                          <label for="benefit-records-label" class="ms-2 mt-2">Benefit Records</label>
                                      </div>
                                  </div>
                                  </div>
                          </ng-container>
                      </p-card>
                  </ng-container>
                  <div class="row" *ngIf="selectedCategory === 'subpoena-to-be-prepared'">
                      <div class="col-sm-12 col-md-12 col-lg-12 mb-3">
                          <label for="record-subpoena-language-{{i}}" class="form-label d-block">Subpoena Language</label>
                          <textarea class="w-100" pTextarea id="record-subpoena-language-textarea-{{i}}" placeholder="Enter subpoena language"
                              formControlName="subpoenaLanguageTextarea"></textarea>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-sm-12 col-md-12 col-lg-12">
                          <label for="record-notes-{{i}}" class="form-label d-block">Notes</label>
                          <textarea class="w-100" pTextarea id="record-notes-textarea-{{i}}" placeholder="Enter text here" formControlName="notesTextarea" sanitizePaste></textarea>
                      </div>
                  </div>  
                <!-- Attachments -->
                <div class="row mb-3 record-attachments-container">
                    <div class="col-sm-12">
                        <ng-container *ngIf="!isRequestDocumentsLoading">
                            <app-attachments [attachments]="getRequestDocuments(i)"
                                [editOrder]="editOrder" [attachmentForm]="record" [parentId]="'record'"
                                [instructionText]="'Upload all request-level attachments (e.g. authorization, subpoena etc.)'"
                                [instructionText2]="'Ensure each uploaded file is under 100 MB and in an accepted format, such as PDF, Excel (XLS/XLSX), CSV, or Word (DOC/DOCX).'"
                                [headerStyleClass]="'hide-panel-header'"
                                [documentType]="'RequestDocumentCode'"
                                [headerText]="'Attachments for Provider ' + (i + 1)"
                                [headerHidden]="true" >
                            </app-attachments>
                        </ng-container>
                    </div>
                </div>
                  </div>
          </p-panel>

            </div>
            <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <p-button label="Add New Provider" styleClass="px-0" icon="pi pi-plus" (onClick)="addNewRecord()"
                        [link]="true" />
                </div>
            </div>
            </form>
            <app-modal [header]="'Delete Confirmation'" [(showDialog)]="showDeleteModal" [rejectLabel]="'No'" [acceptLabel]="'Yes'" (acceptModalClick)="delete()" (rejectModalClick)="showDeleteModal = false">
                <span>Are you sure want to delete this?</span>
            </app-modal>
